import { render, staticRenderFns } from "./SubgroupPaperworkDetailForm.vue?vue&type=template&id=670e4fcb&"
import script from "./SubgroupPaperworkDetailForm.vue?vue&type=script&lang=js&"
export * from "./SubgroupPaperworkDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports